import TceTemplateDiagnostic from './TceTemplateDiagnostic';
export default TceTemplateDiagnostic;
